module.exports = __webpack_public_path__ + "img/background-2.f6ca7684.png";